module.exports = "/_next/static/images/CollectionLibraries-6a46416a1aa9ecce29e3c307fa81a86d.webp";